import { OrderTypes } from './orderTypes';

export default {
  [OrderTypes.FLIGHT]: 'search_icon.png',
  [OrderTypes.HOTEL]: 'search_icon_hotel.png',
  [OrderTypes.CAR]: 'search_icon_car.png',
  [OrderTypes.BUS]: 'search_icon_bus.png',
  [OrderTypes.OFFICE]: 'office.png',
};
